import React, {Component, Fragment} from 'react';
import {Button, Col, Form, Input, Label, FormGroup} from 'reactstrap';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import AsyncSelect from 'react-select/async';
import Loading from 'apa/components/Loading';

@connect(
    state => {
        return {
            customers: state.customers,
            auth: state.apa
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            },
            updateCustomer: (customer) => {
                dispatch(customers.updateCustomer(customer))
            }
        }
    }
)
export default class CustomerBasicDataComponent extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            customer: null,
            changed: false
        };
    }

    componentDidMount() {
        this.fetchCustomer();
    }

    @autobind
    fetchCustomer() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id,
            customer => this.setState({
                isLoaded: true,
                customer: customer
            })
        )
    }

    @autobind
    handleChange(e) {
        const target = e.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState(
            {
                ...this.state,
                changed: true,
                customer: {
                    ...this.state.customer,
                    [name]: value
                }
            }
        )
    }

    @autobind
    handleLocationAddressChange(e) {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        this.setState(
            {
                ...this.state,
                changed: true,
                customer: {
                    ...this.state.customer,
                    location_address: {...this.state.customer.location_address, [name]: value}
                }
            }
        )
    }

    @autobind
    handleInvoiceAddressChange(e) {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        this.setState(
            {
                ...this.state,
                changed: true,
                customer: {
                    ...this.state.customer,
                    invoice_address: {...this.state.customer.invoice_address, [name]: value}
                }
            }
        )
    }

    @autobind
    handleLocationChange(location) {
        const headers = {
            Authorization: `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const body = JSON.stringify({
            location_of: location ? location.value: location
        });
        fetch(
            `/api/customers/${this.state.customer.id}/location_of/`,
            {headers, method: 'PATCH', body}
        )
            .then(res => res.json())
            .then(() => {
                    this.setState(
                        {
                            customer: {
                                ...this.state.customer,
                                location_of: location ? {
                                    id: location.value,
                                    name: location.label
                                } : null
                            }
                        }
                    );
                }
            )
    }

    @autobind
    removeLocation() {
        this.setState(
            {
                customer: {
                    ...this.state.customer,
                    location_of: null
                }
            }
        );
        this.handleLocationChange(this.props.customers.location_of)
    }

    render() {
        const id = this.props.match.params.id;
        const customer = this.state.customer;
        if (!this.state.isLoaded)
            return <Loading/>;
        const {eigenerechnung} = customer;
        const locationAddress = <Fragment>
            <h2>Adresse</h2>
            <FormGroup row>
                <Label for="street" sm={2}>
                    Straße
                </Label>
                <Col sm={4}>
                    <Input value={customer.location_address.street || ''}
                           className="form-control"
                           name="street"
                           onChange={this.handleLocationAddressChange}
                    />
                </Col>
                <Label for="street" sm={2}>
                    Hausnummer
                </Label>
                <Col sm={4}>
                    <Input value={customer.location_address.street_nr || ''}
                           className="form-control"
                           name="street_nr"
                           onChange={this.handleLocationAddressChange}
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Label for="zip" sm={2}>
                    PLZ
                </Label>
                <Col sm={4}>
                    <Input value={customer.location_address.zip || ''}
                           onChange={this.handleLocationAddressChange}
                           className="form-control" type="text" name="zip" id="zip"/>
                </Col>
                <Label for="city" sm={2}>
                    Ort
                </Label>
                <Col sm={4}>
                    <Input value={customer.location_address.city || ''}
                           onChange={this.handleLocationAddressChange}
                           className="form-control"
                           name="city"
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Label for="state" sm={2}>
                    Bundesland
                </Label>
                <Col sm={4}>
                    <Input value={customer.location_address.state || ''}
                           onChange={this.handleLocationAddressChange}
                           className="form-control"
                           name="state"
                    />
                </Col>
                <Label for="land" sm={2}>
                    Land
                </Label>
                <Col sm={4}>
                    <Input value={customer.location_address.country || ''}
                           onChange={this.handleLocationAddressChange}
                           className="form-control"
                           name="country"
                    />
                </Col>
            </FormGroup>
        </Fragment>
        let invoiceAddress = null;
        if(!eigenerechnung && this.state.customer.invoice_address) {
            invoiceAddress = <Fragment>
                <h3>Rechnungsadresse</h3>
                <FormGroup row>
                    <Label for="street" sm={2}>
                        Straße
                    </Label>
                    <Col sm={4}>
                        <Input value={customer.invoice_address.street || ''}
                               className="form-control"
                               name="street"
                               onChange={this.handleInvoiceAddressChange}
                        />
                    </Col>
                    <Label for="street" sm={2}>
                        Hausnummer
                    </Label>
                    <Col sm={4}>
                        <Input value={customer.invoice_address.street_nr || ''}
                               className="form-control"
                               name="street_nr"
                               onChange={this.handleInvoiceAddressChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="zip" sm={2}>
                        PLZ
                    </Label>
                    <Col sm={4}>
                        <Input value={customer.invoice_address.zip || ''}
                               onChange={this.handleInvoiceAddressChange}
                               className="form-control" type="text" name="zip" id="zip"/>
                    </Col>
                    <Label for="city" sm={2}>
                        Ort
                    </Label>
                    <Col sm={4}>
                        <Input value={customer.invoice_address.city || ''}
                               onChange={this.handleInvoiceAddressChange}
                               className="form-control"
                               name="city"
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="state" sm={2}>
                        Bundesland
                    </Label>
                    <Col sm={4}>
                        <Input value={customer.invoice_address.state || ''}
                               onChange={this.handleInvoiceAddressChange}
                               className="form-control"
                               name="state"
                        />
                    </Col>
                    <Label for="land" sm={2}>
                        Land
                    </Label>
                    <Col sm={4}>
                        <Input value={customer.invoice_address.country || ''}
                               onChange={this.handleInvoiceAddressChange}
                               className="form-control"
                               name="country"
                        />
                    </Col>
                </FormGroup>
            </Fragment>
        }
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <Form>
                    <FormGroup row>
                        <Label for="active" sm={2}>
                            Aktuell
                        </Label>
                        <Col sm={4}>
                            <Input checked={customer.active} onChange={this.handleChange} type="checkbox"
                                   name="active"
                                   id="active"/>
                        </Col>
                        <Label for="eigenerechnung" sm={2}>
                            Eigene Rechnung
                        </Label>
                        <Col sm={4}>
                            <Input checked={customer.eigenerechnung} type="checkbox" name="eigenerechnung"
                                   onChange={this.handleChange}
                                   id="eigenerechnung"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="name" sm={2}>
                            Name
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.name} onChange={this.handleChange} className="form-control"
                                   type="text" name="name" id="name"
                                   required/>
                        </Col>
                        <Label for="location_of" sm={2}>
                            Standort von
                        </Label>
                        <Col sm={4}>
                            {
                                customer.location_of &&
                                <Fragment>
                                    {customer.location_of.name}
                                    <Button color='danger' onClick={this.removeLocation}>
                                        <i className='fa fa-times'> </i>
                                    </Button>
                                </Fragment>
                            }
                            {
                                !customer.location_of &&
                                <AsyncSelect name='location_of' cacheOptions defaultOptions
                                             onChange={this.handleLocationChange} loadOptions={
                                    inputValue => {
                                        const headers = {
                                            Authorization: `Token ${this.props.auth.token}`
                                        };
                                        return fetch(
                                            `https://apabackend.quixtest.de/api/customers/active/?search=${inputValue}`,
                                            {headers}
                                        )
                                            .then(res => res.json())
                                            .then(res => {
                                                return res.map(
                                                    option => ({
                                                        value: option.id,
                                                        label: option.name
                                                    })
                                                )
                                            })
                                    }
                                }/>
                            }
                        </Col>
                    </FormGroup>
                    {locationAddress}
                    {invoiceAddress}
                    <hr/>
                    <FormGroup row>
                        <Label for="pa" sm={2}>
                            BG
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.pa || ''}
                                   onChange={this.handleChange}
                                   className="form-control" type="text" name="pa" id="pa"/>
                        </Col>
                        <Label for="panr" sm={2}>
                            BG-Nummer
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.panr || ''}
                                   onChange={this.handleChange}
                                   className="form-control" type="text" name="panr" id="panr"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="coc" sm={2}>
                            Start
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.coc || ''}
                                   onChange={this.handleChange}
                                   className="form-control" type="date" name="coc" id="coc"/>
                        </Col>
                        <Label for="eoc" sm={2}>
                            Ende
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.eoc || ''}
                                   onChange={this.handleChange}
                                   className="form-control" type="date" name="eoc" id="eoc"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="panr" sm={2}>
                            Voraussichtliche Besuche pro Jahr
                        </Label>
                        <Col sm={4}>
                            <Input className="form-control"
                                   value={customer.besuche || ''}
                                   onChange={this.handleChange}
                                   type="number" name="besuche" id="panr"/>
                        </Col>
                        <Label for="wz_code" sm={2}>
                            WZ-Code
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.wz_code || ''}
                                   onChange={this.handleChange}
                                   className="form-control" type="text" name="wz_code"
                                   id="wz_code"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="contract_file" sm={2}>
                            {
                                customer.contract_file &&
                                <a target="_blank" rel="noopener noreferrer" href={customer.contract_file}>Vertrag</a>
                            }
                            {
                                !customer.contract_file &&
                                <span>Vertrag</span>
                            }
                        </Label>
                        <Col sm={4}>
                            <Input value={''}
                                   onChange={this.handleFileChange}
                                   className="form-control" type="file" name="contract_file" id="contract_file"/>
                        </Col>
                        <Label for="eoc" sm={2}>
                            {
                                customer.offer_file &&
                                <a target="_blank" rel="noopener noreferrer" href={customer.offer_file}>Angebot</a>
                            }
                            {
                                !customer.offer_file &&
                                <span>Angebot</span>
                            }
                        </Label>
                        <Col sm={4}>
                            <Input value={''}
                            onChange={this.handleFileChange}
                            className="form-control" type="file" name="offer_file" id="offer_file"/>
                        </Col>
                    </FormGroup>
                    {
                        this.state.changed &&
                        <Fragment>
                            <Button color='primary' onClick={this.saveData}>
                                Speichern
                            </Button>
                            < Button color='default' onClick={this.resetData}>
                                Abbrechen
                            </Button>
                        </Fragment>
                    }
                </Form>
            </DetailContainer>
        )
    }

    @autobind
    handleFileChange(event) {
        this.setState({isLoaded: false})
        const file = event.target.files[0]
        const name = event.target.name
        const headers = {
            Authorization: `Token ${this.props.auth.token}`,
        };
        const body = new FormData()
        body.append(name, file)
        fetch(
            `/api/customers/${this.state.customer.id}/`,
            {headers, method: 'PATCH', body}
        )
            .then(res => res.json())
            .then((res) => {
                    this.setState(
                        {
                            customer: res,
                            isLoaded: true
                        }
                    );
                }
            )

    }

    @autobind
    saveData() {
        const customer = {...this.state.customer};
        delete customer.contract_file
        delete customer.offer_file      
        this.props.updateCustomer(customer);
        this.setState({
            ...this.state,
            changed: false
        })
    }

    @autobind
    resetData() {
        this.setState({
            changed: false,
            customer: this.props.customer
        })
    }
}

